export var ValidationErrorMessages;
(function (ValidationErrorMessages) {
    ValidationErrorMessages["REQUIRED"] = "validation_required";
    ValidationErrorMessages["EMAIL_OR_PHONE"] = "validation_enter_email_or_phone";
    ValidationErrorMessages["EMAIL_OR_PHONE_INVALID"] = "validation_email_or_phone";
    ValidationErrorMessages["ENTER_EMAIL"] = "validation_enter_email";
    ValidationErrorMessages["PASSWORD"] = "validation_enter_password";
    ValidationErrorMessages["EMAIL"] = "validation_email";
    ValidationErrorMessages["LATIN_CHARACTERS"] = "validation_characters";
    ValidationErrorMessages["REFERRER_CODE"] = "validation_referrer";
    ValidationErrorMessages["CONFIRM_PASSWORD"] = "validation_confirmation_password";
    ValidationErrorMessages["PHONE"] = "validation_phone";
    ValidationErrorMessages["SMS_CODE"] = "validation_sms_code";
    ValidationErrorMessages["TWO_FA_CODE"] = "validation_two_fa_code";
    ValidationErrorMessages["EMAIL_TWO_FA_CODE"] = "validation_email_two_fa_code";
    ValidationErrorMessages["LENGTH"] = "validation_length";
    ValidationErrorMessages["NO_SPACE_AT_START_AND_END"] = "validation_no_space_at_start_and_end";
    ValidationErrorMessages["LATIN_CHARACTERS_AND_SPACES"] = "validation_latin_characters_and_spaces";
    ValidationErrorMessages["MIN_LENGTH"] = "validation_min_length";
    ValidationErrorMessages["MAX_LENGTH"] = "validation_max_length";
    ValidationErrorMessages["BANK_WIRE_MIN_AMOUNT"] = "validation_bank_wire_min_amount";
    ValidationErrorMessages["IBAN_FORMAT"] = "validation_iban";
    ValidationErrorMessages["BANK_CODE_FORMAT"] = "validation_bank_code";
    ValidationErrorMessages["PASSWORD_LENGTH"] = "password_char_length";
})(ValidationErrorMessages || (ValidationErrorMessages = {}));
//# sourceMappingURL=validation.js.map